import React, { useCallback, useState } from 'react';
import { Slider } from "antd";
import { langCheck } from "Pub/js/utils.js";
import subjectDefaultData from "Pub/js/subjectDefaultData";
import platform from "Pub/js/platform";
const { NCRadio } = platform.base;
import selectIcon from 'Assets/images/select-icon.svg';
import backgroundImgs from "Pub/js/backgroundImg";
import { SketchPicker } from 'react-color';
import _ from "lodash";
import './index.less';
import ImgChooser from 'Components/ImgChooser';

function BackgroundSetting(props) {
    const {
        bgImgArr,
        bgColorArr,
        getBgColorArr, //个人中心侧边栏需要
        getBackgroundObj,
        getBackgroundObjAndAjax,
        leftAreaTitle,
        backgroundObject,
        bgType,
        allowClick = true,
        handleShade,
        // sliderStyle = { margin: '10px 0 10px 38px' }
    } = props;
    const classNameType = bgType === 'subjectSetting' ? 'bg-set-box-is-subjectsetting' : 'bg-set-box-is-accountsetting';
    const showBgTitle = !!leftAreaTitle;
    let { bgImg, bgColor, blurNumber, bdtype } = backgroundObject;
    const [showSketch, setShowSketch] = useState(false); //色盘显隐    
    const [previewColor, setPreviewColor] = useState(bgColor);

    const getselectObj = (type, value) => {
        const newBackgroundObject = _.cloneDeep(backgroundObject);
        newBackgroundObject[type] = value;
        getBackgroundObjAndAjax(newBackgroundObject, type)

    }
    // 模糊度取值
    const changeSlider = (value) => {
        const newBackgroundObject = _.cloneDeep(backgroundObject);
        newBackgroundObject['blurNumber'] = value;
        getBackgroundObj(newBackgroundObject);
    }
    // 获取模糊值请求接口
    const afterChangeSlider = (value) => {
        getselectObj('blurNumber', value);
    }
    // 背景图片 颜色切换
    const changeBdtype = (value) => {
        getselectObj('bdtype', value);
    }
    // 获取背景图片
    const getBgImg = (value) => {
        getselectObj('bgImg', value)
    }
    // 获取背景颜色
    const getBgColor = (item) => {
        if (item.key === bgColorArr.length - 1) {
            // 色盘
            setShowSketch(true);
            return;
        }
        getselectObj('bgColor', item.name);
        let newBgColorArr = _.cloneDeep(bgColorArr);
        const sketchObj = {
            key: 4,
            color: "linear-gradient(134deg, #CC6767 0%, #3F55F2 21%, #4BCE39 43%, #FFE364 70%, #EC4444 100%)",
            name: 'sketch',
            defaultShow: false,
            fieldid: "sketchBgColor"
        }
        newBgColorArr.map(current => {
            current.defaultShow = current.name === item.name;
            return current;
        })
        newBgColorArr[newBgColorArr.length - 1] = sketchObj;
        getBgColorArr && getBgColorArr(newBgColorArr);

    }

    // 获取取色盘颜色
    const setSketchBg = useCallback(_.debounce((color) => {
        let newBgColorArr = _.cloneDeep(bgColorArr);
        newBgColorArr.map(item => {
            item.defaultShow = false;
            return item;
        })
        const obj = {
            key: newBgColorArr.length - 1,
            color,
            name: 'sketch',
            defaultShow: true,
            fieldid: "sketchBgColor"
        };
        newBgColorArr[newBgColorArr.length - 1] = obj;
        getBgColorArr && getBgColorArr(newBgColorArr);
        getselectObj('bgColor', color);
    }, 200), [props]);
    // 图片背景
    const backgroundImgBox = (data) => {
        const isBase64Img = bgImg && bgImg.includes('base64');
        return (
            <div
                style={bdtype === 'pic' ? { display: 'block' } : { display: 'none' }}
                className='bg-content-box'
            >
                < ul className={`${classNameType}`}>
                    {
                        data.map(item => {
                            const isCustom = item.key === 'custom';
                            const selected = isCustom ? isBase64Img : bgImg === item.type;
                            const bgUrl = isCustom ? (isBase64Img && bgImg) : backgroundImgs[item.type];
                            return <li className='bg-set-box-item' key={item.key} onClick={() => { !isCustom && getBgImg(item.type) }} fieldid={item.fieldid}>
                                <div className={selected ? "select-bg li-top" : "li-top"} >
                                    <div className="li-top-bg" style={bgUrl ? {
                                        background: `url(${bgUrl}) no-repeat center center`,
                                    } : { backgroundColor: '#F1F1F1' }}>
                                        {
                                            isCustom && <ImgChooser
                                                needCrop={false}
                                                onChange={value => {
                                                    getBgImg(value);
                                                }}
                                            >
                                                <i className='iconfont icon-ncc-sq custom-add'></i>
                                            </ImgChooser>
                                        }
                                        {selected && <img className="select-icon" src={selectIcon} alt="" />}
                                    </div>
                                </div>
                            </li>
                        })
                    }
                </ul >
                <p className='blur-title'>{langCheck("0000PUB-000401")}</p>
                <div className='slider-box'>
                    {/* 多语设置-模糊度 */}
                    <Slider
                        className='subject-setting-slider'
                        value={blurNumber}
                        defaultValue={blurNumber}
                        onChange={changeSlider}
                        onAfterChange={afterChangeSlider}
                        tipFormatter={null}
                    />
                    <span className='blur-number'>{blurNumber}%</span>
                </div>
            </div>

        )
    }
    // 颜色背景
    const backgroundColorBox = (data) => {
        return (
            <div
                style={bdtype === 'color' ? { display: 'block', position: 'relative' } : { display: 'none', position: 'relative' }}
                className='bg-content-box'
            >
                < ul className={`${classNameType}`}>
                    {
                        data.map(item =>
                            <li className='bg-set-box-item' key={item.key} onClick={() => { getBgColor(item) }} fieldid={item.fieldid}>
                                <div className={item.defaultShow ? "select-bg li-top" : "li-top"} >
                                    <div className="li-top-bg add-border" style={{
                                        background: item.color,
                                    }}>
                                        {item.defaultShow && <img className="select-icon" src={selectIcon} alt="" />}
                                    </div>
                                </div>
                            </li>
                        )
                    }
                </ul >
                {
                    showSketch && <div className='sketch-bg' onClick={() => { setShowSketch(false) }}></div>
                }
                {
                    <SketchPicker
                        color={subjectDefaultData.bgColorMap[previewColor] || previewColor}
                        onChange={(color) => {
                            const rgbaColor = `rgba(${Object.values(color.rgb).join(', ')})`;
                            setPreviewColor(rgbaColor);
                            setSketchBg(rgbaColor);
                        }}
                        className={showSketch ? 'showSketchPicker' : 'hideSketchPicker'}
                    />
                }
            </div>
        )
    }
    return (
        <div className="item-block vertical bg-set">
            <div className='bg-set-box'>
                {showBgTitle ? leftAreaTitle(langCheck("0000PUB-000398"),
                    "zhutipifu") : <span className="bg-type">{langCheck("0000PUB-000419")}</span>}
                {/* 多语设置-背景设置 */}
                <NCRadio.NCRadioGroup
                    name="fruit"
                    selectedValue={bdtype}
                    onChange={(value) => { changeBdtype(value) }} >
                    {/* 多语设置-颜色背景 */}
                    <NCRadio value="color" >{langCheck("0000PUB-000389")}</NCRadio>
                    {/* 多语设置-背景图片 */}
                    <NCRadio value="pic" >{langCheck("0000PUB-000388")}</NCRadio>
                </NCRadio.NCRadioGroup>
            </div>
            {
                backgroundImgBox(bgImgArr)
            }
            {
                backgroundColorBox(bgColorArr)
            }
            {!allowClick && <div className='bg-show-shade' onClick={handleShade}></div> /** 无权限时遮罩置灰 */}
        </div >
    )

}

export default BackgroundSetting;